import { SET_USER, SET_ISADMIN } from '../actions/actionConstants';
import { User } from '../entities/entities';

export const initialState: User = {
  accessToken: '',
  id: '',
  isAdmin: false,
};

export const UserReducer = (state: User = initialState, action: any) => {
  switch (action.type) {
    case SET_USER:
      return { ...action.payload };
    case SET_ISADMIN:
      return {
        accessToken: state.accessToken,
        id: state.id,
        isAdmin: action.payload,
      };
    default:
      return state;
  }
};
